
var analytics = function(store) {
    return function(next) {
        return function(action) {
            var returnValue = next(action);
            
            if (!action.meta || !action.meta.analytics) {
                return returnValue;
            }

            if (typeof window !== 'undefined') {
                var dataLayer = window.dataLayer;
                var gtm = action.meta.analytics;

                //console.log(JSON.stringify(gtm));
                dataLayer.push({
                    'event': gtm.eventType,
                    'actionValue': gtm.actionValue,
                    'labelValue': gtm.labelValue
                });
            }
            return returnValue;
        };
    };
};

module.exports = analytics;


// WEBPACK FOOTER //
// ./src/common/utils/analytics.js